import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FiltersProjetos {
  codigo_projeto?: string;
  numero_pedido: number;
  titulo?: string;
  nome_cliente?: string;
  email_cliente?: string;
  cpf_cliente?: string;
  n_nota_fiscal?: string;
  criado_por?: string;
  revenda_id?: any;
  distribuidor_id?: any;
  etapa_venda?:{text: string; value: string; model: string; type: string;}[];
  projeto_expirado: {text: string; value: string} | null;
  projeto_kits: {text: string; value: string} | null;
  situacao: {text: string; value: string} | null;
  segmentos: {text: string; value: string} | null;
  origem?: {text: string; value: string} | null;
  migrado?: {text: string; value: string} | null;
  page?: number;
  pageSize?: number;
}
interface Filters {
  projetos: FiltersProjetos;
}

interface FiltersContextType {
  filters: Filters;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
}

const FiltersContext = createContext<FiltersContextType | undefined>(undefined);

interface FiltersProviderProps {
  children: ReactNode;
}

const INITIAL_PROJETOS_FILTER = {
  codigo_projeto: '',
  numero_pedido: 0,
  titulo: '',
  nome_cliente: '',
  email_cliente: '',
  cpf_cliente: '',
  n_nota_fiscal: '',
  criado_por: '',
  revenda_id: null,
  distribuidor_id: null,
  etapa_venda: [],
  situacao: null,
  segmentos: null,
  origem: null,
  migrado: null,
  projeto_kits: null,
  projeto_expirado: null,
}

const INITIAL_FILTERS: Filters = {
  projetos: INITIAL_PROJETOS_FILTER
}

export const FiltersProvider: React.FC<FiltersProviderProps> = ({ children }) => {
  const [filters, setFilters] = useState<Filters>(INITIAL_FILTERS);

  return (
    <FiltersContext.Provider value={{ filters, setFilters }}>
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = (): FiltersContextType => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters deve ser usado dentro de um FiltersProvider');
  }
  return context;
};